import { setStoreValue } from "@/store/utils";

export const SET_INTERVIEW_TEMPLATES = "SET_INTERVIEW_TEMPLATES";
export const SET_IS_FETCHING_INTERVIEW_TEMPLATES =
  "SET_IS_FETCHING_INTERVIEW_TEMPLATES";
export const SET_IS_FETCHING_INTERVIEW_FORMATS =
  "SET_IS_FETCHING_INTERVIEW_FORMATS";
export const SET_INTERVIEW_FORMATS = "SET_INTERVIEW_FORMATS";
export const SET_INTERVIEWERS = "SET_INTERVIEWERS";
export const SET_IS_FETCHING_INTERVIEWERS = "SET_IS_FETCHING_INTERVIEWERS";
export const SET_INTERVIEW_SLOTS = "SET_INTERVIEW_SLOTS";
export const SET_IS_FETCHING_INTERVIEW_SLOTS =
  "SET_IS_FETCHING_INTERVIEW_SLOTS";
export const SET_IS_FETCHING_INTERVIEW_SLOT = "SET_IS_FETCHING_INTERVIEW_SLOT";
export const SET_CURRENT_INTERVIEW_SLOT = "SET_CURRENT_INTERVIEW_SLOT";
export const SET_SELF_SCHEDULE_SLOTS = "SET_SELF_SCHEDULE_SLOTS";
export const SET_IS_FETCHING_SELF_SCHEDULE_SLOTS =
  "SET_IS_FETCHING_SELF_SCHEDULE_SLOTS";
export const SET_CURRENT_INTERVIEW_FORMAT = "SET_CURRENT_INTERVIEW_FORMAT";
export const SET_IS_FETCHING_INTERVIEW_FORMAT =
  "SET_IS_FETCHING_INTERVIEW_FORMAT";
export const SET_FEEDBACK_CRITERIA = "SET_FEEDBACK_CRITERIA";
export const SET_IS_FETCHING_FEEDBACK_CRITERIA =
  "SET_IS_FETCHING_FEEDBACK_CRITERIA";
export const SET_IS_FETCHING_INTERVIEW_INVITES =
  "SET_IS_FETCHING_INTERVIEW_INVITES";
export const SET_INTERVIEW_INVITES = "SET_INTERVIEW_INVITES";

const mutations = {
  [SET_INTERVIEW_TEMPLATES]: setStoreValue("interviewTemplates"),
  [SET_INTERVIEW_FORMATS]: setStoreValue("interviewFormats"),
  [SET_IS_FETCHING_INTERVIEW_TEMPLATES]: setStoreValue(
    "isFetchingInterviewTemplates"
  ),
  [SET_IS_FETCHING_INTERVIEW_FORMATS]: setStoreValue(
    "isFetchingInterviewFormats"
  ),
  [SET_INTERVIEWERS]: setStoreValue("interviewers"),
  [SET_IS_FETCHING_INTERVIEWERS]: setStoreValue("isFetchingInterviewers"),
  [SET_INTERVIEW_SLOTS]: setStoreValue("interviewSlots"),
  [SET_IS_FETCHING_INTERVIEW_SLOTS]: setStoreValue("isFetchingInterviewSlots"),
  [SET_CURRENT_INTERVIEW_SLOT]: setStoreValue("currentInterviewSlot"),
  [SET_IS_FETCHING_INTERVIEW_SLOT]: setStoreValue("isFetchingInterviewSlot"),
  [SET_SELF_SCHEDULE_SLOTS]: setStoreValue("selfScheduleSlots"),
  [SET_IS_FETCHING_SELF_SCHEDULE_SLOTS]: setStoreValue(
    "isFetchingSelfScheduleSlots"
  ),
  [SET_IS_FETCHING_INTERVIEW_FORMAT]: setStoreValue(
    "isFetchingInterviewFormat"
  ),
  [SET_CURRENT_INTERVIEW_FORMAT]: setStoreValue("currentInterviewFormat"),
  [SET_FEEDBACK_CRITERIA]: setStoreValue("feedbackCriteria"),
  [SET_IS_FETCHING_FEEDBACK_CRITERIA]: setStoreValue(
    "isFetchingFeedbackCriteria"
  ),
  [SET_IS_FETCHING_INTERVIEW_INVITES]: setStoreValue(
    "isFetchingInterviewInvites"
  ),
  [SET_INTERVIEW_INVITES]: setStoreValue("interviewInvites")
};

const state = {
  interviewTemplates: [],
  interviewFormats: [],
  interviewers: [],
  isFetchingInterviewTemplates: false,
  isFetchingInterviewFormats: false,
  isFetchingInterviewers: false,
  interviewSlots: [],
  isFetchingInterviewSlots: false,
  isFetchingInterviewSlot: false,
  currentInterviewSlot: null,
  isFetchingSelfScheduleSlots: false,
  selfScheduleSlots: [],
  currentInterviewFormat: null,
  isFetchingInterviewFormat: false,
  feedbackCriteria: [],
  isFetchingFeedbackCriteria: false,
  interviewInvites: [],
  isFetchingInterviewInvites: false
};

export { mutations, state };
